import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'de', flag: '🇩🇪', name: 'Deutsch' },
    { code: 'en', flag: 'EN', name: 'English' },
    { code: 'nl', flag: '🇳🇱', name: 'Nederlands' }
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="flex items-center gap-1">
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => changeLanguage(lang.code)}
          className={`
            flex items-center justify-center min-w-[32px] h-8 px-2 rounded-md
            transition-all duration-200 text-xs font-bold
            ${i18n.language === lang.code 
              ? 'bg-[#C9A961] text-white shadow-sm scale-105' 
              : 'bg-slate-100 text-slate-600 hover:bg-slate-200 hover:scale-105'
            }
          `}
          title={lang.name}
        >
          <span className={lang.code === 'en' ? 'text-xs font-bold' : 'text-base'}>
            {lang.flag}
          </span>
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
